import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Check } from "../../common/game/GameControl";

const CheckButton = () => {
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);

  const currentIndex = useMemo(
    () => gameState.ActivePlayers.findIndex((x) => x.PlayerId === user.Id),
    [gameState.ActivePlayers, user.Id]
  );

  const currentPlayer = useMemo(() => {
    if (currentIndex === -1) return {};
    return gameState.ActivePlayers[currentIndex];
  }, [currentIndex, gameState.ActivePlayers]);

  // DC-FE-CALLCHECK-TDD-GREEN-001: Compute betToPlayer for correct Check/Call semantics
  const betToPlayer = useMemo(() => {
    const currentRoundStatus = currentPlayer.CurrentRoundStatus || 0;
    return gameState.CurrentBet - currentRoundStatus;
  }, [gameState.CurrentBet, currentPlayer.CurrentRoundStatus]);

  const CheckEventHandler = useCallback(
    (ev) => {
      // DC-FE-REMOVE-LOCAL-DISPATCH-002: Call API only, state updated via SignalR "Check" event
      Check(user.Id, gameState.GameCode, currentIndex);
    },
    [currentIndex, gameState, user]
  );

  // DC-FE-CALLCHECK-TDD-GREEN-001: Render Check when betToPlayer === 0 (nothing to call)
  if (
    gameState.CurrentId === user.Id &&
    currentPlayer.PlayerCards?.length > 0 &&
    betToPlayer === 0
  ) {
    return (
      <button className="btn Pass mt-1 me-1 me-md-0" onClick={CheckEventHandler}>
        Check
      </button>
    );
  }
};

export default CheckButton;
